const serialiseUserActionsWatched = watched =>
    watched.config.tileTypes.reduce((output, next) => {
        output[next.type] = next.watchDuration;
        return output;
    }, {});

export default serialiseUserActionsWatched;
